/**
 * Collection page mobile helpers — loaded only on the collection template (≤ 767 px).
 *
 * Splide JS and native horizontal scroll conflict. After Splide mounts we disable
 * drag, reset list transforms, and wire the track for touch swipe scrolling.
 *
 * Category carousel (media_gallery_F9KLPj): Splide is not initialized. Full-card
 * links plus ancestor overflow clipping block native swipe, so pointer drag
 * drives scrollLeft instead.
 */
(function () {
  if (!window.matchMedia('(max-width: 767px)').matches) return;

  var CAROUSEL_PADDING = 20; /* 1.25rem left gutter */
  var PEEK_DIVISOR = 2.22;
  var GAP = 12;
  var SPLIDE_DESTROYED = 7;

  var SECTION_CONFIGS = [
    {
      sectionSelector: '[id*="media_gallery_F9KLPj"]',
      trackSelector: '[id^="x-slide-mobile-"] .splide__track',
      carouselSelector: '[id^="x-slide-mobile-"]',
      slideSelector: ':scope > .splide__slide',
      slideScale: 0.8,
      listWidth: 'max-content',
      unlockCarouselOverflow: true,
      disableAutoHeight: true,
      destroySplide: true,
      pointerScroll: true
    },
    {
      sectionSelector: '[id*="related_collections"]',
      trackSelector: '[id^="x-collection-"].splide > .splide__track',
      carouselSelector: '[id^="x-collection-"].splide',
      slideSelector: ':scope > .splide__slide',
      slideScale: 1
    },
    {
      sectionSelector: '[id*="collage_bQj3RW"]',
      trackSelector: '[id^="collage-"].splide > .splide__track',
      carouselSelector: '[id^="collage-"].splide',
      slideSelector: ':scope > .splide__slide, :scope > [class*="collage-splide-slide-"]',
      slideScale: 1
    }
  ];

  var CAROUSEL_PROPS = [
    'overflow-x', 'overflow-y', 'scroll-snap-type', '-webkit-overflow-scrolling',
    'scrollbar-width', 'width', 'display', 'flex-wrap', 'gap', 'transform',
    'height', 'padding', 'margin', 'max-width', 'min-width', 'flex-shrink',
    'flex', 'margin-right', 'box-sizing', 'overflow', 'scroll-snap-align',
    'scroll-snap-stop', 'touch-action'
  ];

  function imp(el, prop, val) {
    el.style.setProperty(prop, val, 'important');
  }

  function resetCardImageSplides(section) {
    section.querySelectorAll('.card-product .splide__track, .card-product .splide__list, .card-product .splide__slide').forEach(function (el) {
      CAROUSEL_PROPS.forEach(function (prop) {
        el.style.removeProperty(prop);
      });
    });
  }

  function getCarouselTracks(section, config) {
    return Array.from(section.querySelectorAll(config.trackSelector)).filter(function (track) {
      return !track.closest('.card-product');
    });
  }

  function isSplideDestroyed(splide) {
    try {
      return !!(splide && splide.state && splide.state.is && splide.state.is(SPLIDE_DESTROYED));
    } catch (e) {
      return false;
    }
  }

  function releaseSplide(carousel) {
    if (!carousel || carousel._splideReleased) return true;
    var splide = carousel.splide;
    if (!splide) return false;

    if (isSplideDestroyed(splide)) {
      carousel._splideReleased = true;
      return true;
    }

    try {
      splide.options.drag = false;
      if (splide.Components && splide.Components.Drag) {
        splide.Components.Drag.disable(true);
      }
      if (splide.Components && splide.Components.Move && typeof splide.Components.Move.disable === 'function') {
        splide.Components.Move.disable(true);
      }
      splide.destroy(true);
    } catch (e) { /* Splide API may vary */ }

    carousel.classList.remove('is-initialized', 'is-active', 'splide--draggable');
    carousel._splideReleased = true;
    return true;
  }

  function disableSplideDrag(carousel, config) {
    if (!carousel) return;
    var splide = carousel.splide;
    if (!splide || isSplideDestroyed(splide)) return;

    if (!carousel._splideDragDisabled) {
      try {
        splide.options.drag = false;
        if (config && config.disableAutoHeight) {
          splide.options.autoHeight = false;
        }
        if (splide.Components && splide.Components.Drag) {
          splide.Components.Drag.disable(true);
        }
        if (splide.Components && splide.Components.Move && typeof splide.Components.Move.disable === 'function') {
          splide.Components.Move.disable(true);
        }
      } catch (e) { /* Splide API may vary */ }

      carousel._splideDragDisabled = true;
    }

    if (!carousel._splideScrollEventsWired) {
      carousel._splideScrollEventsWired = true;
      ['mounted', 'updated', 'resized', 'refresh'].forEach(function (evt) {
        splide.on(evt, function () {
          var track = carousel.querySelector('.splide__track');
          var list = track && track.querySelector('.splide__list');
          if (list) imp(list, 'transform', 'none');
        });
      });
    }
  }

  function waitThenHandleSplide(carousel, list, config) {
    if (!carousel || carousel._splideWaitWired) return;
    carousel._splideWaitWired = true;

    var splideAttempts = 0;
    var waitForSplide = window.setInterval(function () {
      splideAttempts += 1;
      if (!carousel.isConnected || splideAttempts > 25) {
        window.clearInterval(waitForSplide);
        return;
      }
      if (!carousel.splide) return;

      window.clearInterval(waitForSplide);
      if (config.destroySplide) {
        releaseSplide(carousel);
      } else {
        carousel._splideDragDisabled = false;
        carousel._splideScrollEventsWired = false;
        disableSplideDrag(carousel, config);
      }
      if (list) imp(list, 'transform', 'none');
    }, 200);
  }

  function wireGestureAxisLock(track) {
    if (track._gestureAxisWired) return;
    track._gestureAxisWired = true;

    var startX = 0;
    var startY = 0;
    var axis = null;
    var THRESHOLD = 10;

    track.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      axis = null;
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 1) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;

      if (!axis && (Math.abs(dx) > THRESHOLD || Math.abs(dy) > THRESHOLD)) {
        axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }

      if (axis === 'y') {
        track.style.setProperty('overflow-x', 'hidden', 'important');
      }
    }, { passive: true });

    function resetAxis() {
      axis = null;
      imp(track, 'overflow-x', 'auto');
    }

    track.addEventListener('touchend', resetAxis, { passive: true });
    track.addEventListener('touchcancel', resetAxis, { passive: true });
  }

  function wirePointerScroll(track) {
    if (track._pointerScrollWired) return;
    track._pointerScrollWired = true;

    var startX = 0;
    var startY = 0;
    var startScroll = 0;
    var axis = null;
    var dragging = false;
    var moved = false;
    var pointerId = null;
    var THRESHOLD = 8;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      startX = e.clientX;
      startY = e.clientY;
      startScroll = track.scrollLeft;
      axis = null;
      dragging = true;
      moved = false;
      pointerId = e.pointerId;
      imp(track, 'scroll-snap-type', 'none');
    }, true);

    track.addEventListener('pointermove', function (e) {
      if (!dragging || e.pointerId !== pointerId) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;

      if (!axis && (Math.abs(dx) > THRESHOLD || Math.abs(dy) > THRESHOLD)) {
        axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (axis === 'x') {
          try { track.setPointerCapture(e.pointerId); } catch (err) { /* capture optional */ }
        }
      }

      if (axis === 'x') {
        moved = true;
        track.scrollLeft = startScroll - dx;
        e.preventDefault();
      }
    }, { capture: true, passive: false });

    function endPointer(e) {
      if (!dragging || (pointerId != null && e.pointerId !== pointerId)) return;
      dragging = false;
      pointerId = null;
      imp(track, 'scroll-snap-type', 'x mandatory');

      if (moved) {
        var preventClick = function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          track.removeEventListener('click', preventClick, true);
        };
        track.addEventListener('click', preventClick, true);
        window.setTimeout(function () {
          track.removeEventListener('click', preventClick, true);
        }, 400);
      }

      moved = false;
      axis = null;
    }

    track.addEventListener('pointerup', endPointer, true);
    track.addEventListener('pointercancel', endPointer, true);
    track.addEventListener('dragstart', function (e) {
      e.preventDefault();
    }, true);
  }

  function getSlideWidth(trackW, scale) {
    var viewportW = document.documentElement.clientWidth || window.innerWidth;
    var basis = trackW > 0 ? trackW : Math.max(0, viewportW - CAROUSEL_PADDING);
    return Math.max(96, Math.floor(((basis - GAP) / PEEK_DIVISOR) * (scale || 1)));
  }

  function setupCarousel(section, config) {
    if (!section) return false;

    resetCardImageSplides(section);

    var tracks = getCarouselTracks(section, config);
    if (!tracks.length) return false;

    var anyReady = false;

    tracks.forEach(function (track) {
      var list = track.querySelector('.splide__list');
      if (!list) return;

      var trackW = track.clientWidth;
      if (trackW <= 0) return;

      var slideW = getSlideWidth(trackW, config.slideScale);
      var slides = Array.from(list.querySelectorAll(config.slideSelector));
      if (!slides.length) return;

      var carousel = track.closest(config.carouselSelector);
      if (config.unlockCarouselOverflow && carousel) {
        imp(carousel, 'overflow', 'visible');
      }

      if (config.destroySplide) {
        if (!releaseSplide(carousel)) {
          waitThenHandleSplide(carousel, list, config);
        }
      } else {
        disableSplideDrag(carousel, config);
        if (carousel && !carousel.splide) {
          waitThenHandleSplide(carousel, list, config);
        }
      }

      imp(track, 'overflow-x', 'auto');
      imp(track, 'overflow-y', 'hidden');
      imp(track, 'scroll-snap-type', 'x mandatory');
      imp(track, '-webkit-overflow-scrolling', 'touch');
      imp(track, 'scrollbar-width', 'none');
      imp(track, 'touch-action', config.pointerScroll ? 'pan-y' : 'pan-x pan-y');
      imp(track, 'width', '100%');
      imp(track, 'padding-left', '0');
      imp(track, 'padding-right', '0');

      imp(list, 'display', 'flex');
      imp(list, 'flex-wrap', 'nowrap');
      imp(list, 'gap', GAP + 'px');
      imp(list, 'transform', 'none');
      imp(list, 'width', config.listWidth || 'auto');
      imp(list, 'min-width', config.listWidth === 'max-content' ? '100%' : '0');
      imp(list, 'height', 'auto');
      imp(list, 'padding', '0');
      imp(list, 'margin', '0');

      slides.forEach(function (slide) {
        imp(slide, 'width', slideW + 'px');
        imp(slide, 'max-width', slideW + 'px');
        imp(slide, 'min-width', slideW + 'px');
        imp(slide, 'flex', '0 0 ' + slideW + 'px');
        imp(slide, 'flex-shrink', '0');
        imp(slide, 'margin-right', '0');
        imp(slide, 'margin-left', '0');
        imp(slide, 'box-sizing', 'border-box');
        imp(slide, 'overflow', 'hidden');
        imp(slide, 'scroll-snap-align', 'start');
        slide.style.removeProperty('scroll-snap-stop');
      });

      if (config.pointerScroll) {
        wirePointerScroll(track);
      } else {
        wireGestureAxisLock(track);
      }

      if (!section._carouselTouchPauseWired) {
        section._carouselTouchPauseWired = true;
        function pauseResets() {
          section._carouselResetPaused = true;
        }
        function resumeResets() {
          window.setTimeout(function () {
            section._carouselResetPaused = false;
          }, 120);
        }
        section.addEventListener('pointerdown', function (e) {
          if (e.target.closest('.splide__track')) pauseResets();
        }, { capture: true });
        section.addEventListener('touchstart', function (e) {
          if (e.target.closest('.splide__track')) pauseResets();
        }, { passive: true, capture: true });
        section.addEventListener('pointerup', resumeResets, { capture: true });
        section.addEventListener('pointercancel', function () {
          section._carouselResetPaused = false;
        }, { capture: true });
        section.addEventListener('touchend', resumeResets, { passive: true, capture: true });
        section.addEventListener('touchcancel', function () {
          section._carouselResetPaused = false;
        }, { passive: true, capture: true });
      }

      track._mobileCarouselReady = true;
      anyReady = true;
    });

    return anyReady;
  }

  function setupSection(config) {
    var section = document.querySelector(config.sectionSelector);
    if (!section) return true;
    return setupCarousel(section, config);
  }

  function setupAll() {
    var allOk = true;
    SECTION_CONFIGS.forEach(function (config) {
      if (!setupSection(config)) allOk = false;
    });
    return allOk;
  }

  function trySetup(attemptsLeft) {
    var ok = setupAll();
    if (!ok && attemptsLeft > 0) {
      var delay = attemptsLeft >= 5 ? 200 : attemptsLeft === 4 ? 500 : attemptsLeft === 3 ? 900 : attemptsLeft === 2 ? 1400 : 2200;
      setTimeout(function () { trySetup(attemptsLeft - 1); }, delay);
    }
  }

  function resetSectionCarousels(section, config) {
    if (!section || section._carouselResetPaused) return;
    getCarouselTracks(section, config).forEach(function (track) {
      track._mobileCarouselReady = false;
    });
    section.querySelectorAll(config.carouselSelector).forEach(function (carousel) {
      carousel._splideDragDisabled = false;
      carousel._splideScrollEventsWired = false;
    });
    setupCarousel(section, config);
  }

  function init() {
    trySetup(6);

    SECTION_CONFIGS.forEach(function (config) {
      var section = document.querySelector(config.sectionSelector);
      if (!section) return;

      var sectionId = section.id.replace('shopify-section-', '');
      document.addEventListener('eurus:' + sectionId + ':splide-ready', function () {
        resetSectionCarousels(section, config);
      });

      var debounceTimer;
      var observer = new MutationObserver(function () {
        if (!window.matchMedia('(max-width: 767px)').matches) return;
        if (section._carouselResetPaused) return;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () { resetSectionCarousels(section, config); }, 150);
      });
      observer.observe(section, { childList: true, subtree: true });
    });

    window.addEventListener('resize', function () {
      if (!window.matchMedia('(max-width: 767px)').matches) return;
      setupAll();
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    if (!e.target || !e.target.id) return;
    SECTION_CONFIGS.forEach(function (config) {
      if (e.target.matches && e.target.matches(config.sectionSelector)) {
        resetSectionCarousels(e.target, config);
      }
    });
  });
})();
